import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-feed-msg',
  templateUrl: './feed-msg.component.html',
  styleUrls: ['./feed-msg.component.scss']
})
export class FeedMsgComponent implements OnInit {


  @Input() cNews: any;
  @Output() messageEvent  = new EventEmitter<any>();
  showSingleNews=false;
  constructor() { }

  ngOnInit() {
  }
  aprinew(){
    this.showSingleNews=true;
  }
  letta(){

    this.messageEvent.emit(this.cNews);
    this.showSingleNews=false;
  }
  chiudi(){
    this.showSingleNews=false;
  }
}
